module.exports = __webpack_public_path__ + "img/clock.6798ce28.svg";